import { render, staticRenderFns } from "./letterCommitment.vue?vue&type=template&id=55dad478&scoped=true"
import script from "./letterCommitment.vue?vue&type=script&lang=js"
export * from "./letterCommitment.vue?vue&type=script&lang=js"
import style0 from "./letterCommitment.vue?vue&type=style&index=0&id=55dad478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dad478",
  null
  
)

export default component.exports